/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Select, Empty,
} from 'antd';
import JobWorkActions from '@Actions/production/jobWorkActions';
import TemplateRouteActions from '@Actions/production/templateRouteActions';
import KanbanBoard from './KanbanBoard';
import './style.scss';

/**
 *
 */
function KanbanView({
  user,
  getJobWorksKanban, kanbanJobWorks, userIds, searchKeyword, externalCall, getJobWorksKanbanLoading,
  status, tenantIds, groupBy, startDate, endDate, department, moStatus, setSelectedJobWork, resourceGroup, resource,
}) {
  const [call, setCall] = useState(false);
  const [pageInfo, setPageInfo] = useState({
    machine: {
      page: 1, limit: 100,
    },
    work_center: {
      page: 1, limit: 100,
    },
    operator: {
      page: 1, limit: 100,
    },
  });

  useEffect(() => {
    if (tenantIds) {
      getJobWorksKanban({
        groupBy,
        tenantIds,
        orgId: user?.tenant_info?.org_id,
        status,
        page: pageInfo[groupBy]?.page,
        limit: pageInfo[groupBy]?.limit,
        userIds,
        startDate,
        endDate,
        department,
        moStatus,
        searchKeyword,
        resourceGroupId: resourceGroup,
        resourceId: resource,
      });
    }
  }, [call, groupBy, tenantIds, status, userIds, startDate, endDate, department, moStatus, searchKeyword, externalCall]);

  return (
    <Fragment>
      <div className="jw-kanban__wrapper">
        <KanbanBoard
          user={user}
          jobWorks={kanbanJobWorks?.[groupBy]?.job_works?.filter((item) => item?.job_works?.length > 0)}
          loading={getJobWorksKanbanLoading}
          groupBy={groupBy}
          tenantIds={tenantIds}
          setSelectedJobWork={setSelectedJobWork}
        />
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, DepartmentReducers, JobWorkReducers, TemplateRouteReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  departments: DepartmentReducers.departments,
  updateJobWorkLoading: JobWorkReducers.updateJobWorkLoading,
  kanbanJobWorks: JobWorkReducers.kanbanJobWorks,
  getJobWorksKanbanLoading: JobWorkReducers.getJobWorksKanbanLoading,
  updateTemplateRouteStatusLoading: TemplateRouteReducers.updateTemplateRouteStatusLoading,
  updateAssigneeLoading: TemplateRouteReducers.updateAssigneeLoading,
  getJobOperatorsLoading: JobWorkReducers.getJobOperatorsLoading,
  jobOperators: JobWorkReducers.jobOperators,
  orgUsers: TenantReducers.orgUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getJobWorksKanban: (payload, callback) => dispatch(JobWorkActions.getJobWorksKanban(payload, callback)),
  updateJobWork: (payload, callback) => dispatch(JobWorkActions.updateJobWork(payload, callback)),
  updateTemplateRouteStatus: (payload, callback) => dispatch(TemplateRouteActions.updateTemplateRouteStatus(payload, callback)),
  updateAssignee: (payload, callback) => dispatch(TemplateRouteActions.updateAssignee(payload, callback)),
});

KanbanView.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  jobWorks: PropTypes.any,
  updateAssigneeLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(KanbanView));
